import array from './array'

export default function() {
  array()
}
